import { BLACK_1, BLACK_5 } from "baseStyles";
import styled from "styled-components";

export const Viewer2 = styled.div`
  width: 37.5rem;
  height: fit-content;
  background-color: white;
  padding: 4rem 20px;
  margin-top: 20px;
  border: 2px solid gray;

  & > div:nth-child(1) {
    font-weight: 700;
    font-size: 2.4rem;
    line-height: 4.2rem;
  }
  & > div:nth-child(2) {
    margin-top: 0.5rem;
    display: flex;
    font-weight: 300;
    font-size: 1.4rem;
    line-height: 2.4rem;
    color: ${BLACK_5};
    & > div:nth-child(2n) {
      width: 1.6rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  & > div:nth-child(3) {
    width: 100%;
    height: 18.8rem;
    margin: 1.5rem auto;
    img {
      width: 100%;
      height: 100%;
      border-radius: 0.5rem;
    }
  }
  & > div:nth-child(4) {
    margin-top: 2rem;
    font-size: 1.6rem;
    line-height: 2.8rem;
    color: ${BLACK_1};
  }
`;
